export default __webpack_public_path__ + "static/media/ikflogo.9044a7be796d89dbae7899faec9f3394.webp";